import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';

const AccountManagement = lazy(() =>
  import('@repo/ui/features/account/index').then((mod) => ({ default: mod.AccountManagement })),
);

export default function AccountPage() {
  return (
    <div className="w-full py-6">
      <Suspense fallback={<DendromapLoader message="Chargement du compte..." />}>
        <AccountManagement />
      </Suspense>
    </div>
  );
}

